import { useTranslation } from 'react-i18next';
import PageHeader from '@/components/page-header';
import { setWebTitle } from '@/lib/format-utils';
import { useMoneyTransactionsOut } from '@/hooks/api-hooks';
import { SkeletonList } from '@/components/snippets';
import BalanceSummary from '@/components/balance-summary';
import MoneyTransactionsTable from '@/components/money-transactions-table';

export default function MoneyTransactionsOutPage(): JSX.Element {
    const { t } = useTranslation();
    setWebTitle(t('money_out'));

    const {
        data,
        isLoading
    } = useMoneyTransactionsOut({});

    return (
        <div>
            <PageHeader
                title={t('money_out')}
            />
            <div className="panel-content">
                <BalanceSummary moneyTransactions={data?.data || []} />

                <MoneyTransactionsTable
                    moneyTransactions={data?.data || []}
                />

                {isLoading && <SkeletonList />}
            </div>
        </div>
    );
}
